

const Nav = ({
            logo,
            lable,
            isLink = true,
            href,
             }) => (
    
    <div className="navContainer">
    
    </div>
)

export default Nav;
